import { Stack } from '@mui/material'
import SidebarPopup from './SidebarPopup'
import MenuSidebarLink from './MenuSidebarLink'
import { CollapsibleSectionConfig } from '../../store/types/components/sidebar/sidebarTypes'

type SidebarCollapsedContentProps = {
  sections: CollapsibleSectionConfig[]
}

const SidebarCollapsedContent = ({ sections }: SidebarCollapsedContentProps) => (
  <Stack direction="column" gap={0.5} sx={{ alignItems: 'center' }}>
    {sections.map(section => (
      <SidebarPopup
        key={section.key}
        popupId={`${section.key}-popup`}
        open={false}
        Icon={section.icon}
        sidebarLinkText={section.label}
        index={section.links.map(link => link.index)}
      >
        {popupState => (
          <>
            {section.links.map(link => (
              <MenuSidebarLink
                key={link.index}
                text={link.text}
                route={link.route}
                index={link.index}
                popupState={popupState}
              />
            ))}
          </>
        )}
      </SidebarPopup>
    ))}
  </Stack>
)

export default SidebarCollapsedContent
